import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { GroupDetails } from "./components/GroupDetails";

export function GroupPage() {
  return (
    <Page title="Group Details">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <GroupDetails />
      </Container>
    </Page>
  );
}
